import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import strings from "translate/language";
import {
  visitorList,
  getVisiterList,
  visitorFormUpdate,
} from "reduxStore/action/visitorActions";
import { useDispatch, useSelector } from "react-redux";
import {
  CallCenter,
  CPAgent,
  visitorStatus,
  MIS_RoleId,
  GRE,
  isGreRoleId,
  ClosingTL,
  CSTL,
} from "utils/constants";
import AllocateSM from "component/common/AllocateCM";
import VisitorCmAllocationCell from "component/common/VisitorCmAllocationCell";
import { getConfiguration } from "reduxStore/action/masterActions";
import TableDataNotFound from "component/TableDataNotFound";
import { handleDetailResponse, handleListResponse, seo } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import usePermission from "utils/usePermission";
import Button from "component/Button";
import moment from "moment";
import usePage from "utils/usePage";
import Pagination from "component/common/Pagination";
import { getReportPropertyList } from "reduxStore/action/reportActions";
import Select from "react-select";
import { getAgentProperty } from "reduxStore/action/propertyActions";
import {
  getVisitorCurrentCmId,
  getVisitorCurrentCmName,
  isVisitorAllocatedToCm,
} from "utils/visitorCmAllocation";
import "./VisitorListing.css";

const getVisitorStatusBadgeClass = (leadStatus) => {
  const status = Number(leadStatus);
  if (status === 1) return "visitor-status-badge--new";
  if (status === 2) return "visitor-status-badge--followup";
  if (status === 3 || status === 7) return "visitor-status-badge--ready";
  if (status === 4 || status === 5) return "visitor-status-badge--booking";
  return "visitor-status-badge--default";
};

const formatVisitorBudget = (item, isCpView) => {
  if (item?.budget_amount) {
    return item.budget_amount;
  }

  if (isCpView) {
    const min = `${item?.min_rate || ""}${item?.min_rate ? item.min_rate_type : ""}`.trim();
    const max = `${item?.max_rate || ""}${item?.max_rate ? item.max_rate_type : ""}`.trim();
    if (!min && !max) return null;
    return `${min}${min && max ? " - " : ""}${max}`.trim();
  }

  const min = `${item?.min_budget || ""}${item?.min_budget ? item.min_budget_type : ""}`.trim();
  const max = `${item?.max_budget || ""}${item?.max_budget ? item.max_budget_type : ""}`.trim();
  if (!min && !max) return null;
  return `${min}${min && max ? " - " : ""}${max}`.trim();
};

const Visitor = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const [page, setPage] = usePage();
  const [formVaild, setFormVaild] = useState({});
  const [endDateDisable, setEndDateDisable] = useState(true);
  const [getvisitorList, setVisitorList] = useState([]); // Always initialize as array
  const [propertyList, setPropertyList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initialQueryFilterTriggered, setInitialQueryFilterTriggered] =
    useState(false);
  const [showAllocateModal, setShowAllocateModal] = useState(false);
  const [selectedVisitor, setSelectedVisitor] = useState(null);
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const lastAllocatedLeadIdRef = useRef(null);
  const visitorListSelector = useSelector((state) => state?.visitor);
  const ReportListSelector = useSelector((state) => state.report);
  const propertySelector = useSelector((state) => state.propertyData);
  const visitorConfiguration = useSelector(
    (state) => state.visitorConfiguration,
  );

  console.log("Visitor grid data", getvisitorList);

  const { response: res } = useSelector((state) => state.login);
  const misRole = MIS_RoleId === res?.data?.role_id;
  const roleId = res?.data?.role_id;
  // Convert both to strings for comparison to handle ObjectId vs string
  const currentRoleId = String(roleId || "").trim();
  const closingTlRoleId = String(ClosingTL || "").trim();
  const cstlRoleId = String(CSTL || "").trim();
  const isGRE = isGreRoleId(roleId);
  const canAllocateToCM =
    isGRE || currentRoleId === closingTlRoleId || currentRoleId === cstlRoleId;

  // Debug log (remove in production)
  console.log("Visitor List - GRE Check:", {
    roleId: currentRoleId,
    isGRE,
    loginData: res?.data,
  });

  const cpId = useSelector((state) => {
    let response = handleDetailResponse(state.login.response?.data);
    if (response.role_id === CallCenter) {
      return true;
    } else if (response.role_id === CPAgent) {
      return response?.cp_id;
    }
    return false;
  });

  useEffect(() => {
    dispatch(visitorFormUpdate({}));
  }, [dispatch]);

  const [visitorConfigurationData, setvisitorConfigurationData] = useState([]);
  const { create, view, edit, isAdmin, bulk } = usePermission({
    create: "add_visitor",
    view: "view_visitor",
    edit: "edit_visitor",
    bulk: "bulk_upload",
  });
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const [form, setForm] = useState({
    start_date: "",
    end_date: "",
    limit: "",
    offset: "",
    visit_score: "",
    search_by_visisor_name: "",
    search_configuration: "",
    search_property_name: "",
    search_by_mobile_number: "",
    draft: "",
    qualified: "",
    lead_priority: "",
  });

  useEffect(() => {
    const start_date = query.get("start_date");
    const end_date = query.get("end_date");

    if (start_date && end_date) {
      setForm((prev) => ({
        ...prev,
        start_date,
        end_date,
      }));
      setEndDateDisable(false);
      setInitialQueryFilterTriggered(true);
    }
  }, []);

  // Wait until form has start/end date from query before filtering
  useEffect(() => {
    if (initialQueryFilterTriggered && form.start_date && form.end_date) {
      filterDetail();
      setInitialQueryFilterTriggered(false);
    }
  }, [initialQueryFilterTriggered, form.start_date, form.end_date]);

  useEffect(() => {
    dispatch(visitorFormUpdate({}));
  }, [dispatch]);

  useEffect(() => {
    if (form.start_date === "") {
      setEndDateDisable(true);
    } else {
      setEndDateDisable(false);
    }
  }, [form.start_date]);

  useEffect(() => {
    seo({
      title: "Visitor Listing",
      metaDescription: "Visitor listing",
      canonicalLink: window.location.href,
    });
  }, []);

  const handleValid = () => {
    let err = { ...formVaild };
    let formError = false;
    if (form.start_date !== "" && form.end_date === "") {
      formError = true;
      err["end_date"] = strings.endDateErr;
    }
    setFormVaild(err);
    return formError;
  };

  const filterDetail = () => {
    if (!handleValid()) {
      const commonParams = {
        limit: 10,
        offset: 0,
        start_date: form.start_date,
        end_date: form.end_date,
        visit_score: form.visit_score,
        search_configuration: form.search_configuration,
        search_by_visisor_name: form.search_by_visisor_name,
        search_by_mobile_number: form.search_by_mobile_number,
        draft: form.draft,
        qualified: form.qualified,
        lead_priority: form.lead_priority,
      };

      if (isAdmin) {
        dispatch(
          visitorList({
            ...commonParams,
            search_property_name: form?.site?.property_title,
            search_type: cpId ? 1 : 2,
          }),
        );
      } else {
        dispatch(
          getVisiterList({
            ...commonParams,
            property_id: form?.site?._id,
          }),
        );
      }
      setPage(0);
    }
  };

  const filterReset = () => {
    setForm({
      start_date: "",
      end_date: "",
      visit_score: "",
      search_configuration: "",
      search_by_visisor_name: "",
      search_property_name: "",
      site: "",
      search_by_mobile_number: "",
      draft: "",
      lead_priority: "",
      qualified: "",
    });
    setFormVaild({ ...formVaild, end_date: "" });
    if (isAdmin) {
      dispatch(
        visitorList({ search_type: cpId ? 1 : 2, limit: 10, offset: 0 }),
      );
    } else {
      dispatch(getVisiterList({ limit: 10, offset: 0 }));
    }
    setPage(0);
  };

  const handleInputField = (e) => {
    const nextFormState = { ...form, [e.target.name]: e.target.value };
    setForm(nextFormState);
    if (e.target.name === "end_date") {
      setFormVaild({ ...formVaild, end_date: "" });
    }
  };

  const handlePageClick = (newOffset) => {
    setPage(newOffset);
    const commonParams = {
      limit: 10,
      offset: newOffset,
      start_date: form.start_date,
      end_date: form.end_date,
      visit_score: form.visit_score,
      search_configuration: form.search_configuration,
      search_by_visisor_name: form.search_by_visisor_name,
      search_by_mobile_number: form.search_by_mobile_number,
      draft: form.draft,
      qualified: form.qualified,
      lead_priority: form.lead_priority,
    };

    if (isAdmin) {
      dispatch(
        visitorList({
          ...commonParams,
          search_property_name: form?.site?.property_title,
          search_type: cpId ? 1 : 2,
        }),
      );
    } else {
      dispatch(
        getVisiterList({
          ...commonParams,
          property_id: form?.site?._id,
        }),
      );
    }
  };

  // Fetch initial list
  useEffect(() => {
    if (isAdmin) {
      dispatch(
        visitorList({ search_type: cpId ? 1 : 2, limit: 10, offset: page }),
      );
    } else {
      dispatch(getVisiterList({ limit: 10, offset: page }));
    }
  }, [dispatch, page]);

  // Populate visitor list
  useEffect(() => {
    if (visitorListSelector?.response?.status === 200) {
      let visitorData = visitorListSelector?.response?.data || [];
      const safeVisitorData = Array.isArray(visitorData) ? visitorData : [];
      // GRE: after allocate, keep allocated lead out of list when refetch completes
      if (lastAllocatedLeadIdRef.current) {
        const idToExclude = String(lastAllocatedLeadIdRef.current);
        visitorData = safeVisitorData.filter(
          (v) => String(v._id || v.lead_id || "") !== idToExclude,
        );
        lastAllocatedLeadIdRef.current = null;
      } else {
        visitorData = safeVisitorData;
      }
      setVisitorList(visitorData);

      // Debug: Log visitor data for GRE role (remove in production)
      if (
        isGRE &&
        Array.isArray(safeVisitorData) &&
        safeVisitorData.length > 0
      ) {
        console.log(
          "Visitor List Data (GRE):",
          safeVisitorData.map((v) => ({
            _id: v._id,
            property_id: v.property_id,
            for_sm_id: v.for_sm_id,
            first_name: v.first_name,
          })),
        );
      }
    } else {
      setVisitorList([]);
    }
  }, [visitorListSelector, isGRE]);

  // Load property list
  useEffect(() => {
    if (isAdmin) {
      dispatch(getReportPropertyList({ limit: 10, offset: 0 }));
    } else {
      dispatch(getAgentProperty({ offset: 0, limit: "" }));
    }
  }, [dispatch]);

  useEffect(() => {
    if (visitorConfiguration?.response?.status === 200) {
      setvisitorConfigurationData(visitorConfiguration.response.data);
    } else {
      setvisitorConfigurationData([]);
    }
  }, [visitorConfiguration]);

  useEffect(() => {
    if (!isAdmin && propertySelector?.response?.status === 200) {
      const filtered = propertySelector.response.data?.filter(
        (item) => item.status === true,
      );
      setPropertyList(filtered?.length > 0 ? handleListResponse(filtered) : []);
    }
  }, [propertySelector, isAdmin]);

  useEffect(() => {
    if (isAdmin && ReportListSelector?.reportPropertyList?.status === 200) {
      setPropertyList(
        handleListResponse(ReportListSelector.reportPropertyList.data),
      );
    }
  }, [ReportListSelector]);

  useEffect(() => {
    dispatch(getConfiguration());
  }, [dispatch]);

  useEffect(() => {
    const sidebarEl = document.querySelector(".page-sidebar");
    const headerEl = document.querySelector(".page-main-header");

    const syncSidebarLayout = () => {
      const sidebarHidden =
        sidebarEl?.classList.contains("open") ||
        headerEl?.classList.contains("open");
      setSidebarExpanded(!sidebarHidden);
    };

    syncSidebarLayout();

    const observer = new MutationObserver(syncSidebarLayout);
    [sidebarEl, headerEl].forEach((el) => {
      if (el) {
        observer.observe(el, {
          attributes: true,
          attributeFilter: ["class"],
        });
      }
    });

    window.addEventListener("resize", syncSidebarLayout);

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", syncSidebarLayout);
    };
  }, []);

  const visitorTableMinWidth = canAllocateToCM ? 1188 : 1088;

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.visitor}
        parentListing={null}
        titleactive={strings.visitorList}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form className="theme-form">
                      <div className="row">
                        <div className="col-md-4">
                          <span className="cardText">{strings.startDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              data-target="#dt-date"
                              name="start_date"
                              value={form.start_date}
                              onChange={handleInputField}
                              min={form.start_date}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">{strings.endDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              name="end_date"
                              value={form.end_date}
                              onChange={handleInputField}
                              min={form.start_date}
                              // max={form.end_date}
                              disabled={endDateDisable}
                            />
                          </div>
                          {formVaild.end_date && (
                            <span style={{ color: "red" }}>
                              {formVaild.end_date}
                            </span>
                          )}
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByVisitorName}
                          </span>
                          <input
                            className="form-control datetimepicker-input digits"
                            type="text"
                            autoComplete="off"
                            placeholder={strings.searchVisitorName}
                            name="search_by_visisor_name"
                            value={form.search_by_visisor_name}
                            onChange={handleInputField}
                          />
                        </div>
                      </div>

                      <div className="row pt-3">
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByConfiguration}
                          </span>
                          <select
                            className="form-control digits"
                            id="formcontrol-select1"
                            name="search_configuration"
                            value={form.search_configuration}
                            onChange={handleInputField}
                          >
                            <option value="">
                              {strings.selectConfiguration}
                            </option>
                            {visitorConfigurationData?.length ? (
                              visitorConfigurationData.map((item, index) => (
                                <option key={index} value={item._id}>
                                  {item.title}
                                </option>
                              ))
                            ) : (
                              <option>{strings.Loading}</option>
                            )}
                          </select>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByVistingScore}
                          </span>
                          <select
                            className="form-control digits"
                            id="formcontrol-select1"
                            name="visit_score"
                            onChange={handleInputField}
                            value={form.visit_score}
                          >
                            <option defaultValue={null}>
                              {strings.selectVisitingScore}
                            </option>
                            <option value={"1"}>{strings.howToligh}</option>
                            <option value={"2"}>{strings.highTolow}</option>
                          </select>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByPropertyName}
                          </span>
                          <Select
                            isSearchable
                            isClearable
                            onInputChange={(e) => {
                              if (isAdmin) {
                                if (e.length > 1) {
                                  dispatch(
                                    getReportPropertyList({
                                      search_site: e,
                                      isLoadMore: true,
                                    }),
                                  );
                                } else {
                                  dispatch(
                                    getReportPropertyList({
                                      limit: 10,
                                      offset: 0,
                                      isLoadMore: true,
                                    }),
                                  );
                                }
                              }
                            }}
                            placeholder={strings.searchByPropertyName}
                            options={propertyList}
                            getOptionLabel={(option) =>
                              `${option.property_title}`
                            }
                            getOptionValue={(option) => option._id}
                            name="site"
                            value={form.site}
                            onChange={(e) => {
                              setForm({ ...form, site: e });
                            }}
                          />
                        </div>
                      </div>

                      <div className="row pt-3">
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByMobileNumber}
                          </span>
                          <input
                            className="form-control datetimepicker-input digits"
                            type="text"
                            autoComplete="off"
                            placeholder={strings.searchMobileNumber}
                            name="search_by_mobile_number"
                            value={form.search_by_mobile_number}
                            onChange={handleInputField}
                            maxLength="10"
                          />
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">{strings.leadStatus}</span>
                          <select
                            className="form-control digits"
                            id="formcontrol-select1"
                            name="qualified"
                            onChange={handleInputField}
                            value={form.qualified}
                          >
                            <option value={""}>
                              {strings.selectLeadStatus}
                            </option>
                            <option value={true}>{strings.qualified}</option>
                            <option value={false}>{strings.unQualified}</option>
                          </select>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.leadPriority}
                          </span>
                          <select
                            className="form-control digits"
                            id="formcontrol-select1"
                            name="lead_priority"
                            onChange={handleInputField}
                            value={form.lead_priority}
                          >
                            <option value={""}>
                              {strings.selectLeadPriority}
                            </option>
                            <option value={"hot"}>{strings.hot}</option>
                            <option value={"warm"}>{strings.warm}</option>
                            <option value={"cold"}>{strings.cold}</option>
                          </select>
                        </div>
                      </div>

                      <div className="row pt-3">
                        {/* Left side: Mobile Number Input */}
                        {isAdmin ? (
                          <div className="col-md-4"></div>
                        ) : (
                          <div className="col-md-4">
                            <span className="cardText">
                              {strings.searchByVistingType}
                            </span>
                            <select
                              className="form-control digits"
                              id="formcontrol-select1"
                              name="draft"
                              onChange={handleInputField}
                              value={form.draft}
                            >
                              <option value="">{strings.visitors}</option>
                              {/* <option value={""}>{strings.visitors}</option> */}
                              <option value={true}>
                                {strings.draftVisitors}
                              </option>
                            </select>
                          </div>
                        )}
                        <div className="col-md-4"></div>
                        <div className="col-md-4">
                          <div className=" d-flex align-items-end justify-content-end mt-4">
                            <button
                              className="btn btn-warning mr-2"
                              type="button"
                              onClick={filterDetail}
                            >
                              {strings.search}
                            </button>
                            <button
                              className="btn btn-dark"
                              type="button"
                              onClick={filterReset}
                            >
                              {strings.reset}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-xl-12">
                <div
                  className={`card visitor-listing-card${
                    sidebarExpanded ? " visitor-listing-card--constrained" : ""
                  }`}
                  style={{
                    "--visitor-table-min-width": `${visitorTableMinWidth}px`,
                  }}
                >
                  <div className="card-header">
                    <h5>{strings.listOfVisitor}</h5>
                    {!isAdmin && create ? (
                      <Button
                        className="btn btn-color visitor-listing-card__add-btn"
                        onClick={() => navigatpage("/visitor_form")}
                        label={strings.addNewVisitor}
                      />
                    ) : null}
                  </div>
                  <div className="table-responsive">
                    <table className="table visitor-listing-table">
                      <colgroup>
                        <col style={{ width: 130 }} />
                        <col style={{ width: 130 }} />
                        <col style={{ width: 136 }} />
                        <col style={{ width: 104 }} />
                        <col style={{ width: 100 }} />
                        <col style={{ width: 112 }} />
                        <col style={{ width: 68 }} />
                        <col style={{ width: 128 }} />
                        {canAllocateToCM ? (
                          <col style={{ width: 100 }} />
                        ) : null}
                        <col style={{ width: 80 }} />
                      </colgroup>
                      <thead>
                        <tr>
                          <th
                            scope="col"
                            className="visitor-listing-table__property-col"
                          >
                            {strings.propertyName}
                          </th>
                          <th
                            scope="col"
                            className="visitor-listing-table__name-col"
                          >
                            {strings.visitorName}
                          </th>
                          <th
                            scope="col"
                            className="visitor-listing-table__date-col"
                          >
                            {strings.createdDate}
                          </th>
                          <th
                            scope="col"
                            className="visitor-listing-table__source-col"
                          >
                            {strings.sourceName}
                          </th>
                          <th
                            scope="col"
                            className="visitor-listing-table__config-col"
                          >
                            {strings.configuration}
                          </th>
                          <th
                            scope="col"
                            className="visitor-listing-table__budget-col"
                          >
                            {strings.budget}
                          </th>
                          <th
                            scope="col"
                            className="visitor-listing-table__score-col"
                          >
                            {strings.visitScore}
                          </th>
                          <th
                            scope="col"
                            className="visitor-listing-table__status-col"
                          >
                            {strings.status}
                          </th>
                          {canAllocateToCM ? (
                            <th
                              scope="col"
                              className="visitor-listing-table__cm-col"
                            >
                              {strings.allocatedToCM}
                            </th>
                          ) : null}
                          <th
                            scope="col"
                            className="visitor-listing-table__actions-col"
                          >
                            {strings.action}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {getvisitorList?.length > 0 ? (
                          (Array.isArray(getvisitorList)
                            ? getvisitorList
                            : []
                          ).map((item, index) => {
                            const showEditAction =
                              edit &&
                              item?.lead_status <= 3 &&
                              !misRole &&
                              !isAdmin;
                            const showAllocateAction =
                              canAllocateToCM &&
                              item?.property_id &&
                              item?.lead_status <= 3;
                            const visitorAllocatedToCm =
                              isVisitorAllocatedToCm(item);
                            const showReallocateAction =
                              showAllocateAction && visitorAllocatedToCm;
                            const showFirstAllocateAction =
                              showAllocateAction && !visitorAllocatedToCm;
                            const currentCmId = getVisitorCurrentCmId(item);
                            const currentCmName = getVisitorCurrentCmName(item);
                            const visitorName =
                              `${item?.first_name || ""} ${item?.last_name || ""}`.trim();
                            const budgetText = formatVisitorBudget(item, !!cpId);
                            const statusLabel =
                              visitorStatus[item?.lead_status] || "—";
                            return (
                              <tr key={index}>
                                <td className="visitor-listing-table__property-col">
                                  <div className="visitor-listing-table__cell-text">
                                    <span
                                      className="visitor-listing-table__primary-text"
                                      title={item?.property_title || "—"}
                                    >
                                      {item?.property_title || "—"}
                                    </span>
                                  </div>
                                </td>
                                <td className="visitor-listing-table__name-col">
                                  <div className="visitor-listing-table__cell-text">
                                    <span
                                      className="visitor-listing-table__primary-text"
                                      title={visitorName || "—"}
                                    >
                                      {visitorName || "—"}
                                    </span>
                                  </div>
                                </td>
                                <td className="visitor-listing-table__date-col">
                                  <div className="visitor-listing-table__cell-center">
                                    <span
                                      className="visitor-listing-table__date"
                                      title={moment(item.createdDate).format(
                                        "DD-MM-yyyy hh:mm a",
                                      )}
                                    >
                                      {moment(item.createdDate).format(
                                        "DD-MM-yyyy hh:mm a",
                                      )}
                                    </span>
                                  </div>
                                </td>
                                <td className="visitor-listing-table__source-col">
                                  <div className="visitor-listing-table__cell-text">
                                    <span
                                      className="visitor-listing-table__secondary-text"
                                      title={item?.created_for_sm_name || "—"}
                                    >
                                      {item?.created_for_sm_name || "—"}
                                    </span>
                                  </div>
                                </td>
                                <td className="visitor-listing-table__config-col">
                                  <div className="visitor-listing-table__cell-center">
                                    {item?.configuration ? (
                                      <span
                                        className="visitor-listing-table__secondary-text"
                                        title={item.configuration}
                                      >
                                        {item.configuration}
                                      </span>
                                    ) : (
                                      <span className="visitor-listing-table__empty">
                                        —
                                      </span>
                                    )}
                                  </div>
                                </td>
                                <td className="visitor-listing-table__budget-col">
                                  <div className="visitor-listing-table__cell-center">
                                    {budgetText ? (
                                      <span
                                        className="visitor-listing-table__budget"
                                        title={budgetText}
                                      >
                                        {budgetText}
                                      </span>
                                    ) : (
                                      <span className="visitor-listing-table__empty">
                                        —
                                      </span>
                                    )}
                                  </div>
                                </td>
                                <td className="visitor-listing-table__score-col">
                                  <div className="visitor-listing-table__cell-center">
                                    <span className="visitor-listing-table__metric">
                                      {item?.lead_score ?? "—"}
                                    </span>
                                  </div>
                                </td>
                                <td className="visitor-listing-table__status-col">
                                  <div className="visitor-listing-table__cell-center">
                                    <span
                                      className={`visitor-status-badge ${getVisitorStatusBadgeClass(
                                        item?.lead_status,
                                      )}`}
                                      title={statusLabel}
                                    >
                                      <span
                                        className="visitor-status-badge__dot"
                                        aria-hidden="true"
                                      />
                                      <span className="visitor-status-badge__label">
                                        {statusLabel}
                                      </span>
                                    </span>
                                  </div>
                                </td>
                                {canAllocateToCM ? (
                                  <td className="visitor-listing-table__cm-col">
                                    <div className="visitor-listing-table__cell-center">
                                      <VisitorCmAllocationCell
                                      strings={strings}
                                      disabled={showAllocateModal}
                                      cmName={currentCmName || item?.created_for_cm_name}
                                      state={
                                        showReallocateAction
                                          ? "allocated"
                                          : showFirstAllocateAction
                                            ? "pending"
                                            : "inactive"
                                      }
                                      onAllocate={() => {
                                        setSelectedVisitor({
                                          leadId: item._id,
                                          propertyId: item.property_id,
                                          visitorName,
                                          isReallocate: false,
                                        });
                                        setShowAllocateModal(true);
                                      }}
                                      onReallocate={() => {
                                        setSelectedVisitor({
                                          leadId: item._id,
                                          propertyId: item.property_id,
                                          visitorName,
                                          currentCmId,
                                          currentCmName:
                                            currentCmName ||
                                            item.created_for_cm_name ||
                                            "",
                                          isReallocate: visitorAllocatedToCm,
                                        });
                                        setShowAllocateModal(true);
                                      }}
                                    />
                                    </div>
                                  </td>
                                ) : null}
                                <td className="visitor-listing-table__actions-col">
                                  <div className="visitor-listing-table__cell-center">
                                    <div className="visitor-listing-table__actions">
                                      {view ? (
                                        <button
                                          type="button"
                                          className="visitor-action-btn"
                                          title={strings.viewVisitor}
                                          onClick={() => {
                                            navigatpage(
                                              `/viewvisitor/${item._id}`,
                                            );
                                          }}
                                        >
                                          <i
                                            className="fa fa-eye"
                                            aria-hidden="true"
                                          />
                                        </button>
                                      ) : (
                                        <span
                                          className="visitor-action-btn visitor-action-btn--placeholder"
                                          aria-hidden="true"
                                        />
                                      )}
                                      {showEditAction ? (
                                        <button
                                          type="button"
                                          className="visitor-action-btn"
                                          title={strings.editVisitor}
                                          onClick={() => {
                                            const path =
                                              item.draft === true
                                                ? `/visitor_form_draft?lead_id=${item._id}`
                                                : `/visitor_form?lead_id=${item._id}`;
                                            navigatpage(path);
                                          }}
                                        >
                                          <i
                                            className="fa fa-edit"
                                            aria-hidden="true"
                                          />
                                        </button>
                                      ) : (
                                        <span
                                          className="visitor-action-btn visitor-action-btn--placeholder"
                                          aria-hidden="true"
                                        />
                                      )}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr />
                        )}
                      </tbody>
                    </table>
                    <TableDataNotFound data={getvisitorList} />
                  </div>
                  <Pagination
                    totalCount={visitorListSelector?.response?.total_data}
                    listData={getvisitorList}
                    onPageChange={handlePageClick}
                    itemOffset={page}
                    setItemOffset={setPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* JUSTO-64: GRE/CTL – Allocate to Closing Manager / SCM modal */}
      {canAllocateToCM && selectedVisitor && (
        <AllocateSM
          show={showAllocateModal}
          propertyId={selectedVisitor.propertyId}
          leadId={selectedVisitor.leadId}
          visitorName={selectedVisitor.visitorName}
          isReallocate={selectedVisitor.isReallocate}
          currentCmId={selectedVisitor.currentCmId}
          currentCmName={selectedVisitor.currentCmName}
          handleClose={() => {
            setShowAllocateModal(false);
            setSelectedVisitor(null);
            // Do not refetch here – on success, onAllocateSuccess refetches; on cancel, list unchanged.
            // Refetching here caused a second response to overwrite the list and bring the allocated row back.
          }}
          onAllocateSuccess={() => {
            const leadIdToRemove = selectedVisitor?.leadId;
            const isReallocate = selectedVisitor?.isReallocate;
            setShowAllocateModal(false);
            setSelectedVisitor(null);
            // GRE first-time allocate: remove visitor from list (unallocated-only GRE view).
            if (leadIdToRemove && !isReallocate) {
              lastAllocatedLeadIdRef.current = leadIdToRemove;
              const idStr = String(leadIdToRemove);
              setVisitorList((prev) =>
                Array.isArray(prev)
                  ? prev.filter(
                      (v) => String(v._id || v.lead_id || "") !== idStr,
                    )
                  : prev,
              );
            }
            // Refresh visitor list from API to keep in sync
            if (isAdmin) {
              dispatch(
                visitorList({
                  search_type: cpId ? 1 : 2,
                  limit: 10,
                  offset: page,
                }),
              );
            } else {
              dispatch(getVisiterList({ limit: 10, offset: page }));
            }
          }}
        />
      )}
    </div>
  );
};
export default Visitor;
